var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_4271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99521 10.6692H1.59375C1.04356 10.6692 0.597656 11.1154 0.597656 11.6653V33.004C0.597656 33.5542 1.04356 34.0001 1.59375 34.0001H7.99521C8.54539 34.0001 8.9913 33.5542 8.9913 33.004V11.6653C8.9913 11.1154 8.54539 10.6692 7.99521 10.6692ZM6.99911 32.0079H2.58984V12.6614H6.99911V32.0079Z",
    fill: "#844C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79474 0C2.48038 0 0.597656 1.88272 0.597656 4.19656C0.597656 6.51093 2.48038 8.39339 4.79474 8.39339C7.10884 8.39339 8.9913 6.51067 8.9913 4.19656C8.9913 1.88272 7.10884 0 4.79474 0ZM4.79474 6.4012C3.57893 6.4012 2.58984 5.41237 2.58984 4.19656C2.58984 2.98102 3.57893 1.99219 4.79474 1.99219C6.01028 1.99219 6.99911 2.98102 6.99911 4.19656C6.99911 5.41237 6.01028 6.4012 4.79474 6.4012Z",
    fill: "#844C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 10.5283C22.4856 10.5283 20.9933 10.8933 19.6569 11.576C19.6115 11.0679 19.1848 10.6692 18.6647 10.6692H12.2627C11.7128 10.6692 11.2666 11.1153 11.2666 11.6653V33.004C11.2666 33.5542 11.7128 34.0001 12.2627 34.0001H18.6647C19.2149 34.0001 19.6608 33.5542 19.6608 33.004V21.2677C19.6608 19.758 20.8893 18.5298 22.399 18.5298C23.9087 18.5298 25.1367 19.758 25.1367 21.2677V33.004C25.1367 33.5542 25.5829 34.0001 26.1328 34.0001H32.5345C33.0847 34.0001 33.5306 33.5542 33.5306 33.004V20.0592C33.5306 14.8037 29.2552 10.5283 23.9997 10.5283ZM31.5384 32.0079H27.1291V21.2677C27.1291 18.6595 25.0072 16.5376 22.3992 16.5376C19.7907 16.5376 17.6686 18.6595 17.6686 21.2677V32.0079H13.259V12.6614H17.6686V13.3973C17.6686 13.7804 17.8883 14.1296 18.2338 14.2953C18.5791 14.4611 18.9889 14.4139 19.288 14.1744C20.6369 13.0925 22.2664 12.5205 23.9997 12.5205C28.1566 12.5205 31.5384 15.9023 31.5384 20.0592V32.0079Z",
    fill: "#844C0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_4271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinicon);
export default __webpack_public_path__ + "static/media/linkdinicon.75812e0a71f2184e254658592286e002.svg";
export { ForwardRef as ReactComponent };